<div class="row justify-content-center">
  <div class="col-md-8 col-lg-8 col-12">
    <h3>{{ "accounts.email_change.title" | translate }}</h3>
      <form #form="ngForm" (ngSubmit)="form.form.valid && submit(form)" novalidate>
        <p>{{ "accounts.email_change.confirm_info" | translate }}</p>
        <div class="row">          
          <div class="col-12">
            <div class="form-group">
              <label>{{ "accounts.email_change.password" | translate }}</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button [ngClass]="showPassword ? 'btn rounded-left btn-outline-success' : 'btn rounded-left btn-outline-primary'" type="button"
                          (click)="this.showPassword = !this.showPassword"><i [ngClass]="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></button>
                </div>
                <input [type]="showPassword ? 'text' : 'password'" class="form-control" name="password" [(ngModel)]="password" #passwordVal="ngModel" [ngClass]="inputFieldCss(passwordVal, form)" [minLength]="6" required>
              </div>
              <div class="text-right">
                <label style="font-size: small">{{ "shared.login.show-password" | translate }}</label>
                <input class="ml-2" type="checkbox" name="newNip2" value="nip" [(ngModel)]="showPassword">
              </div>
              <app-field-error-display [control]="passwordVal" [form]="form"></app-field-error-display>
            </div>
          </div>

          <div class="col-12">
            <div class="alert-info text-info" role="alert">
              <span>
                <i class="fas fa-info-circle"></i>
                &nbsp;
                {{ "accounts.email_change.confirm_info" | translate }}
              </span>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>{{ "accounts.email_change.new_email" | translate }}</label>
              <input type="email" class="form-control" name="email" [(ngModel)]="email" #emailVal="ngModel" [ngClass]="inputFieldCss(emailVal, form)" app-email required>
              <app-field-error-display [control]="emailVal" [form]="form"></app-field-error-display>
            </div>
          </div>
        </div>
        <div class="col-12 text-right">
          <button type="submit" class="btn btn-primary">{{ "accounts.email_change.change" | translate }}</button>
        </div>
      </form>
    </div>
  </div>

